import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { Toast, ToastOptions } from "./toastTypes";

interface ToastState {
	toasts: Toast[];
	showToast: (options: ToastOptions) => string;
	dismissToast: (id: string) => void;
	clearAll: () => void;
}

const DEFAULT_DURATION = 3000;

export const useToastStore = create<ToastState>()(
	devtools(
		(set, get) => ({
			toasts: [],
			showToast: (options) => {
				const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
				const toast: Toast = {
					id,
					message: options.message,
					type: options.type,
					title: options.title,
					duration: options.duration ?? DEFAULT_DURATION,
				};
				set((state) => ({ toasts: [...state.toasts, toast] }));
				if (toast.duration && toast.duration > 0) {
					setTimeout(() => get().dismissToast(id), toast.duration);
				}
				return id;
			},
			dismissToast: (id) =>
				set((state) => ({
					toasts: state.toasts.filter((t) => t.id !== id),
				})),
			clearAll: () => set({ toasts: [] }),
		}),
		{ name: "ToastStore" },
	),
);
